import { Document, Page, Text, View, Link, Image, 
    StyleSheet, ReactPDF, PDFDownloadLink } from '@react-pdf/renderer';
import { isNullOrUndefined, isUndefined } from "util";
import * as AnalyticsUtil from '../../../../common/AnalyticsSvc';
import * as Const from '../../../../common/const';
import * as Utils from '../../../../common/utilSvc';
import './generalData.css';

export const renderSummary = (generalData) =>{
    if(!isNullOrUndefined(generalData) && 
        (('summaryText' in generalData) || ('companyMission' in generalData)))
    {
        let summaryText = null, companyMission = null;
        if('summaryText' in generalData)
            summaryText = generalData['summaryText'];
        if('companyMission' in generalData){
            companyMission  = generalData.companyMission;
            //title and link
        }
        return (
              <View> 
                <View style={{margin:'5px 10px 5px 10px', backgroundColor:'#dfebf0', padding: '10px'}}>
                    <Text style={{textAlign:'center', fontFamily:'Times-Bold', fontSize:'16px', marginBottom:'15px'}}>{Const.filterData['Summary'].name}</Text>
                    {!isNullOrUndefined(summaryText)?
                            <View style={{flexDirection: 'row', marginBottom: '10px'}}>
                                <Text style={{width: 10, fontSize: 10}}>•</Text>
                                <Text style={{fontSize: '12px', fontFamily:'Times-Roman'}}>
                                    {summaryText.data} (<Link style={{color:'blue'}} src={summaryText.link}>Source</Link>)
                                </Text>
                            </View>
                            :
                            null
                    }
                    {!isNullOrUndefined(companyMission)?
                            <View style={{flexDirection: 'row', marginBottom: '10px'}}>
                                <Text style={{width: 10, fontSize: 10}}>•</Text>
                                <Text style={{fontSize: '12px', fontFamily:'Times-Roman'}}>
                                    <Text style={{fontFamily:'Times-Bold'}}>Mission:</Text> {companyMission.snippet} (<Link style={{color:'blue'}} src={companyMission.link}>Source</Link>)
                                </Text>
                            </View>
                            :
                            null
                    }
                </View>
              </View>
        )
    }

    return (
        null
    );
}

const canRenderKeyFacts = (generalData) => {
    if(isNullOrUndefined(generalData))
        return false;

    let canRenderKeyFacts = false;
    let generalWikiData = Const.generalWikiData;
    for(let i=0; i<generalWikiData.length; i++){
        if(generalWikiData[i] in generalData)
        {
            canRenderKeyFacts = true;
            break;
        }
    }
    return canRenderKeyFacts;
}

export const renderFinancialData = (generalData, amCharts) =>{
    if(!(!isNullOrUndefined(generalData) && 
        ('incomeStatement' in generalData || 
        !isNullOrUndefined(generalData.funding)))){
            return null;
        }

        let fundingNewsArr = [];
        if(!isNullOrUndefined(generalData.funding)){
            for(let i=0; i<generalData.funding.length && i<Const.maxFundingNewsArticles; i++){
                fundingNewsArr.push(generalData.funding[i]);
            }
        }
        let renderFundingNews = null;
        // console.log(fundingNewsArr);

        renderFundingNews = fundingNewsArr.map((news) => {
            return (
                <View>
                    {renderNewsCard(news)}
                </View>
            )
        })

        let incomeStatement = null;
        if('incomeStatement' in generalData){
            incomeStatement = generalData.incomeStatement;
            // console.log(incomeStatement);
        }
    
    return (
        <View style={{margin: '5px 10px 5px 10px', backgroundColor:'#dfebf0', padding:'10px'}}>
            <Text style={{textAlign:'center', fontFamily:'Times-Bold', fontSize:'16px', marginBottom:'15px'}}>{Const.filterData['Financial Details'].name}</Text>
            {fundingNewsArr.length>0?
                    <View>
                        <Text style={{textAlign:'left', fontFamily:'Times-Bold', fontSize:'14px', marginBottom:'10px'}}>Funding News</Text>
                        {renderFundingNews}
                    </View>
                    :
                    null
            }

            {!isNullOrUndefined(incomeStatement)?
                <View>
                    <Text style={{textAlign:'left', fontFamily:'Times-Bold', fontSize:'14px', marginBottom:'10px'}}>Income Statement</Text>
                    <Link style={{color:'blue', fontSize:'12px'}} src={incomeStatement.link}>View Income statement</Link>
                </View>
                :
                null
            }

        </View>
    )
}

export const renderKeyFacts = (generalData) => {
    if(!canRenderKeyFacts(generalData)){
        return null;
    }

    let generalWikiData = Const.generalWikiData;
        let renderArr = [];
        for(let i=0; i<generalWikiData.length && !isNullOrUndefined(generalData);i++){
            // console.log(generalData);
            if(generalWikiData[i] in generalData){
                renderArr.push({
                    'key': generalWikiData[i],
                    'val': generalData[generalWikiData[i]].data,
                    'link': generalData[generalWikiData[i]].link
                })

                if(renderArr[renderArr.length-1].key!='website'){
                    renderArr[renderArr.length-1].val = Utils.capitalizeFirstLetter(String(renderArr[renderArr.length-1].val))
                }
                else{
                    let websiteLink = renderArr[renderArr.length-1].val
                    if(!websiteLink.includes('https://') && !websiteLink.includes('http://')){
                        renderArr[renderArr.length-1].val = "https://" + renderArr[renderArr.length-1].val;
                    }
                }
            }
        }
        // console.log(renderArr);

        const renderlistItems = renderArr.map((data) =>
             <View style={{marginBottom:'10px'}}>
                 <Text style={{fontSize:'12px', fontFamily:'Times-Roman'}}>
                    <Text>{Utils.capitalizeFirstLetter(data.key)}: </Text>
                    {data.key == 'website'?
                         <Link style={{fontFamily:'Times-Bold', color:'blue'}} src={data.val}>{data.val} </Link>
                         :
                         null
                    }
                    {data.key != 'website'?
                         <Text style={{fontFamily:'Times-Bold'}}>{!isNullOrUndefined(data.val) && data.val.toLowerCase()!='undefined'?data.val:null} </Text>
                         :
                         null
                    }
                    (<Link style={{color:'blue'}} src={data.link}>Source</Link>)
                 </Text>
            </View>
        );

        return (
            <View style={{margin: '5px 10px 5px 10px', backgroundColor:'#dfebf0', padding:'10px'}}>
                <Text style={{textAlign:'center', fontFamily:'Times-Bold', fontSize:'16px', marginBottom:'15px'}}>{Const.filterData['Key Facts'].name}</Text>
                <View style={{backgroundColor:'white', border: '0.5px black solid', padding:'10px'}}>
                    {renderlistItems}
                </View>
            </View>
        )

    
} 

const renderNewsCard = (news) => {
    if(isNullOrUndefined(news))
        return null;
    
    return (
        <View style={{padding:'10px', marginBottom:'10px', backgroundColor:'white', border:'0.5px solid darkgrey'}}>
            {!isNullOrUndefined(news.source)?
                <Text style={{fontSize:'12px', color:'grey',fontFamily:'Times-Bold', marginBottom: '8px'}}>
                    {news.source}
                </Text>
                :
                null
            }

            {!isNullOrUndefined(news.title)?
                <Text style={{fontSize:'15px', fontFamily:'Times-Roman', marginBottom: '8px'}}>
                    {news.title}
                </Text>
                :
                null
            }

            {!isNullOrUndefined(news.snippet)?
                <Text style={{fontSize:'12px', fontFamily:'Times-Roman', marginBottom: '8px'}}>
                    {!isNullOrUndefined(news.date)?
                    <Text style={{color:'grey', fontFamily:'Times-Bold'}}>{news.date}: </Text>
                        :
                        null    
                    }                    
                    {news.snippet}
                </Text>
                :
                null
            }

            {!isNullOrUndefined(news.link)? 
                (<Link src={news.link} style={{fontSize:'10px', color:'blue'}}>Source</Link>)
                :
                null
            }
        </View>
    )
}

export const renderCompanyNews = (generalData) => {
    if(!(!isNullOrUndefined(generalData) && 'companyNews' in generalData && generalData['companyNews'].length>0)){
        return null;
    }
    let companyNews = generalData['companyNews'];
    let renderNews = null;
    renderNews = companyNews.map((news) => {
        return (
            <View>
                {renderNewsCard(news)}
            </View>

        )
    })

    return (
        <View style={{margin: '5px 10px 5px 10px', backgroundColor:'#dfebf0', padding:'10px'}}>
            <Text style={{textAlign:'center', fontFamily:'Times-Bold', fontSize:'16px', marginBottom:'15px'}}>{Const.filterData['News'].name}</Text>
            {renderNews}
        </View>
    )

}

export const renderGeneralDataPdf = (generalData, amCharts) =>{
    //console.log(generalData);
    
    let imageUrl = null;
    if(!isNullOrUndefined(generalData) && !isNullOrUndefined(generalData.imageLogo)){
        imageUrl = generalData.imageLogo.url;
        if(!imageUrl.includes("https")){
            imageUrl = "https://"+generalData.imageLogo.url;
        }
    }

    return (
        <Document>
            <Page>
                {!isNullOrUndefined(imageUrl)?
                    <View style={{margin:'10px 0 10px 0'}}>
                            <Image 
                            style={{maxHeight:'150px', maxWidth:'150px', marginLeft:'auto', marginRight:'auto', display: 'block'}}
                            src={imageUrl}
                            >                    
                            </Image>
                    </View>
                    :
                    null
                }
                {renderSummary(generalData)}
                {renderKeyFacts(generalData)}
                {renderCompanyNews(generalData)}
                {renderFinancialData(generalData, amCharts)}
            </Page>
        </Document>
    )
}